<template>
  <div class="page-content">
    <div class="page-title">我的关注</div>
    <div class="page-tabs clearfix">
      <div class="tab-item active">
        <span>学校</span>
      </div>
    </div>
    <div class="follow-list">
      <div
        class="local-school-list-item"
        v-for="item in schoolFollowList"
        :key="item.id"
      >
        <div class="local-school-left">
          <div class="school-logo">
            <img :src="item.schoolLogo" alt="" />
          </div>
          <div class="school-detail">
            <!-- data-io-click="tracker"  @click="goSchoolHome(item)" -->
            <div class="school-name" v-html="item.schoolName"></div>
            <div class="school-num">
              <span>{{ item.stageTagName }}</span>
              <span>共{{ item.documentNum }}份</span>
              <span>关注数：{{ item.followNum }}</span>
            </div>
          </div>
        </div>
        <div class="local-school-right">
          <div class="btn follow-btn" data-io-click="tracker"  @click="cancelFollow(item)">取消关注</div>
          <!-- <div class="btn introl-btn" data-io-click="tracker"  @click="goSchoolHome(item)">学校主页</div> -->
        </div>
      </div>
    </div>
    <NoContent
      :type="5"
      message="<p>您好，这里没有您关注的学校</p><p>查看学校主页时，可以添加关注</p>"
      v-if="!schoolFollowList.length && !isSchoolFollowListLoading"
    />
    <div class="pages" v-if="schoolFollowList.length && totalPages > 1">
      <el-pagination
        background
        @size-change="pageSizeChange"
        @current-change="pageIndexChange"
        :current-page="pageIndex"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="totalPages"
      >
      </el-pagination>
    </div>
    <TipDialog
      :visible="isShowTipDialog"
      @close="isShowTipDialog = false"
      @confirm="handleConfirm"
      title="确定不再关注"
    ></TipDialog>
  </div>
</template>
<script>
import query from "@/assets/js/mixin/query";
import resource from "@/assets/js/mixin/resource";
import NoContent from "@/components/NoContent.vue";
import TipDialog from "@/components/TipDialog.vue";
import { cancelSchoolFollow, getSchoolFollowList } from "@/utils/apis";
export default {
  name: "follow",
  mixins: [query, resource],
  components: {
    NoContent,
    TipDialog,
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        console.log("newVal", newVal);
        let { pageIndex, pageSize } = this.$route.query;
        if (!pageIndex || !pageSize) {
          this.addParams();
        }
        this.getFollowList();
      },
      immediate: true,
    },
  },
  data() {
    return {
      schoolFollowList: [],
      pageSize: 30,
      pageIndex: 1,
      isSchoolFollowListLoading: true,
      isShowTipDialog: false,
    };
  },
  mounted() {
    let { pageIndex, pageSize } = this.$route.query;
    this.pageIndex = Number(pageIndex);
    this.pageSize = Number(pageSize);
  },
  methods: {
    async getFollowList() {
      this.isSchoolFollowListLoading = true;
      let { pageIndex, pageSize } = this.$route.query;
      if (!pageIndex || !pageSize) {
        return;
      }
      const res = await getSchoolFollowList({
        pageIndex: Number(pageIndex),
        pageSize: Number(pageSize),
      });
      this.totalPages = res.result.totalPages;
      console.log(res);
      this.schoolFollowList = res.result.list || [];
      this.isSchoolFollowListLoading = false;
    },
    addParams() {
      this.updateQuery({}, true);
    },
    // 更新路由的query
    updateQuery(obj, isReset, method = "push") {
      if (!Object.keys(this.$route.query).length) {
        method = "replace";
      }
      if (isReset) {
        this.pageIndex = 1;
        const book = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        const query = { ...book, ...(obj || {}) };
        console.log("query", query);
        // 路由重置
        this.$router[method]({ query });
      } else {
        let query = JSON.parse(JSON.stringify(this.$route.query));
        this.$router[method]({
          query: { ...query, ...(obj || {}) },
        });
      }
    },
    async handleConfirm() {
      try {
        // 调用关注/取消关注接口
        const res = await cancelSchoolFollow({ schoolId: this.schoolId });
        // console.log(res);
        if (res.result) {
          this.getFollowList();
        }
      } catch (err) {
        console.error("关注操作失败:", err);
        this.$message.error("操作失败,请稍后重试");
      }
      this.isShowTipDialog = false;
    },
    async cancelFollow(item) {
      // 根据当前关注状态选择对应的方法
      // try {
      //   await this.$confirm("确定不再关注?", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     center: true,
      //   });
      // } catch {
      //   return; // 用户取消操作
      // }
      this.schoolId = item.schoolId;
      this.isShowTipDialog = true;
      // try {
      //   // 调用关注/取消关注接口
      //   const res = await cancelSchoolFollow({ schoolId: item.schoolId });
      //   console.log(res);
      //   if (res.result) {
      //     this.getFollowList();
      //   }
      // } catch (err) {
      //   console.error("关注操作失败:", err);
      //   this.$message.error("操作失败,请稍后重试");
      // }
      // const res = await cancelSchoolFollow({ schoolId: item.schoolId });
      // console.log(res);
      // if (res.result) {
      //   this.getFollowList();
      // }
    },
    goSchoolHome(item) {
      console.log(item);
      window.open(`/zyk/mingxiao?schoolId=${item.schoolId}&pageId=10`);
    },
  },
};
</script>
<style lang="scss" scoped>
.page-content {
  padding: 48px 52px 48px;
  .page-title {
    font-size: 18px;
    line-height: 26px;
    position: relative;
    margin-bottom: 24px;
    &::after {
      display: block;
      position: absolute;
      content: "";
      bottom: -8px;
      left: 0px;
      width: 31px;
      height: 2px;
      background: #0057ff;
    }
  }
  .page-tabs {
    border-bottom: 1px solid #eaeff2;
    margin-bottom: 24px;
    .tab-item {
      border-radius: 8px 8px 0px 0px;
      background: #eaeff2;
      padding: 0 32px;
      height: 40px;
      line-height: 40px;
      color: #0057ff;
      font-size: 16px;
      cursor: pointer;
      &::after {
        display: none;
      }
    }
  }
}
.local-school-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  //   margin-right: 38px;
  // cursor: pointer;
  padding: 20px 0;
  border-bottom: 1px solid #e2e2e2;
  .school-logo {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    margin-right: 12px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .school-detail {
    .school-name {
      font-size: 14px;
      font-weight: bold;
      line-height: 22px;
      margin-bottom: 2px;
      ::v-deep .key {
        color: #0057ff;
      }
    }
    .school-num {
      display: flex;
      span {
        padding: 0 12px;
        position: relative;
        line-height: 20px;
        color: #666;
        font-size: 12px;
        &:first-child {
          padding-left: 0;
          &::after {
            position: absolute;
            content: "";
            display: inline-block;
            width: 1px;
            height: 16px;
            top: 2px;
            right: 0;
            background: #e2e2e2;
          }
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
  }
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    // .school-name {
    //   color: #0057ff;
    // }
  }
  .local-school-left {
    display: flex;
    align-items: center;
  }
  .local-school-right {
    display: flex;
    align-items: center;
    .btn {
      display: flex;
      height: 24px;
      min-width: 64px;
      padding: 0px 8px;
      font-size: 12px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &.follow-btn {
        background: #fff;
        color: #0057ff;
        border: 1px solid #0057ff;
        &:hover {
          background: #e6f2ff;
        }
      }
      &.introl-btn {
        background: #0057ff;
        color: #fff;
        margin-left: 16px;
        border: 1px solid transparent;
        &:hover {
          background: #4494ff;
        }
      }
    }
  }
}
::v-deep .no-content-box {
  .tip-title {
    margin-right: 0;
    width: 196px;
    margin: 0 auto;
    margin-top: 8px;
    text-align: center;
  }
}
.pages {
  padding-bottom: 34px;
}
</style>
